import { Pipe, PipeTransform } from '@angular/core';
import { GridItem, GridColumn } from '../grid-control.model';

@Pipe({
  name: 'cellMobileClassName'
})
export class CellMobileClassNamePipe implements PipeTransform {
  transform(value: any, rowData: GridItem, column: GridColumn): string {
    const classNames = [];
    if (column.click) {
      classNames.push('cursor-pointer');
    }
    if (column.badge) {
      const badge = column.badge(rowData, value);
      if (badge) {
        classNames.push('badge');
        classNames.push('c-badge');
        if (badge === 'PRIMARY') {
          classNames.push('badge-primary');
        } else if (badge === 'SECONDARY') {
          classNames.push('badge-secondary');
        } else if (badge === 'WARNING') {
          classNames.push('badge-warning');
        } else if (badge === 'SUCCESS') {
          classNames.push('badge-success');
        } else if (badge === 'DANGER') {
          classNames.push('badge-danger');
        } else if (badge === 'LIGHT') {
          classNames.push('badge-light');
        } else if (badge === 'DARK') {
          classNames.push('badge-dark');
        }
      }
    }
    return classNames.join(' ');
  }
}
